import classNames from 'classnames';
import React, { useState } from 'react';
import { Maybe } from '@types';

type Props = {
  showReadMore?: boolean;
  content: Maybe<string>;
  hideTitle?: boolean;
};

const Description = ({ showReadMore = false, content, hideTitle = false }: Props) => {
  const [expanded, setExpanded] = useState(false);

  if (!content) return null;

  const descriptionParagraphs = content
    .split('<p>')
    .filter((i) => i.trim())
    .map((i) => '<p>' + i);

  return (
    <div className='tw:my-5 tw:border-t tw:border-gray-200 tw:px-4 tw:py-5 tw:md:border-t-0'>
      <div className='tw:mx-auto tw:max-w-[715px]'>
        {!hideTitle && (
          <p className='tw:mb-0 tw:hidden tw:text-center tw:font-title tw:text-2xl tw:font-bold tw:md:mb-5 tw:md:block'>
            Description
          </p>
        )}
        <div
          className='tw:text-sm tw:font-light tw:text-body tw:md:text-base tw:[&_*]:text-sm tw:[&_*]:md:!text-base tw:[&_b]:font-bold tw:[&_p]:mb-3'
          dangerouslySetInnerHTML={{
            __html: showReadMore ? descriptionParagraphs[0] : content,
          }}></div>

        {showReadMore && descriptionParagraphs.length > 1 && (
          <React.Fragment>
            <div
              className={classNames(
                'tw:mb-4 tw:overflow-x-hidden tw:text-base tw:font-light tw:text-body tw:transition-all tw:duration-300',
                {
                  'tw:max-h-0 tw:overflow-y-hidden': !expanded,
                  'tw:max-h-[800px] tw:overflow-y-scroll': expanded,
                }
              )}
              dangerouslySetInnerHTML={{
                __html: descriptionParagraphs.slice(1).join(''),
              }}></div>
            <span
              onClick={() => setExpanded((prevState) => !prevState)}
              className='tw:cursor-pointer tw:text-base tw:font-normal tw:underline tw:transition tw:duration-300 tw:hover:opacity-75'>
              Read {expanded ? 'Less' : 'More'}
            </span>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default Description;
